export default __webpack_public_path__ + "static/media/akela_tours_pascal.15cf73e3.jpg";